import ScriptLoader from "./ScriptLoader";

const isActive = (obj: any) =>
  obj && typeof obj === "object" && obj.status === true;

export default function AnalyticsScripts({
  rybbit,
  googleTag,
  analyticsTag,
  ga4Tag,
  yektanetTag,
  clarity,
}: any) {
  return (
    <>
      {isActive(rybbit) && (
        <ScriptLoader
          id="rybbit-analytics"
          src={rybbit.src}
          data-site-id={rybbit.siteId}
          strategy={rybbit.strategy}
          defer={rybbit.defer}
        />
      )}

      {isActive(googleTag) && (
        <ScriptLoader 
          id="gtm-head"
          strategy={googleTag.strategy}
        >
          {googleTag.head}
        </ScriptLoader>
      )}

      {isActive(analyticsTag) && (
        <ScriptLoader
          id="gtag-src"
          src={analyticsTag.src}
          strategy={analyticsTag.strategy}
        />
      )}

      {isActive(ga4Tag) && (
        <ScriptLoader 
          id="ga4-config"
          strategy={ga4Tag.strategy}
        >
          {ga4Tag.src}
        </ScriptLoader>
      )}

      {isActive(yektanetTag) && (
        <ScriptLoader 
          id="yektanet"
          strategy={yektanetTag.strategy}
        >
          {yektanetTag.src}
        </ScriptLoader>
      )}
      
      {isActive(clarity) && (
        <ScriptLoader 
          id="clarity"
          strategy={clarity.strategy}
        >
          {clarity.src}
        </ScriptLoader>
      )}

      {isActive(googleTag) && (
        <noscript
          dangerouslySetInnerHTML={{
            __html: `<iframe src="${googleTag.body}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
          }}
        />
      )}
    </>
  );
}
